<template>
<div class="chapter">
<div class="inner_page">
<p class="intro-head">Introducing: A <i>SewCanShe Book</i></p>
<p class="s-txt">Hello sewing fans! We are very excited to bring to you this collection of sewing projects written by many of our very favorite bloggers, with a few of our own designs as well.</p>
<p class="s-txt">Most of us spend our time sewing for our children, grandchildren, friends, and neighbors but hardly ever take the time to sew for ourselves. We want to make it easy for you to take occasional breaks from all of your <i>selfless</i> sewing and do some <i>selfish</i> sewing instead. We are giving you a challenge (and an excuse) to sew something for yourself every month of the year. The projects in this book are organized into twelve chapters for the twelve months of the year to keep you sewing sweet little projects all year long. You’ll find clothing pieces, tote bags, purses, and accessories—all to make you feel spoiled.</p>
<p class="s-txt">Enjoy the beautiful pictures, reminiscent of a blog tutorial. We are sure you will find that in many cases a picture really does explain better than a thousand words. The projects in this book are written for sewists who have had some sewing experience but may still consider themselves beginners.</p>
<p class="s-txt">Be sure to check out Techniques You’ll Use for lots of tips (including how to make continuous bias trim) and a refresher of the things you’ll need to know.</p>
<p class="s-txt">Let the Selfish Sewing begin!</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 06_intro.vue?c5272bfe